import React from 'react';
import {
  DateRangeDropdownV2 as DateRangeField,
  DocumentNumberRangeFieldV2 as DocumentNumberRangeField,
  FormField,
  SearchField
} from '@/components/custom/erp';
import { accountSearchColumns, khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import { KhachHang, TaiKhoan } from '@/types/schemas';
import { useSearchFieldState } from '../../hooks';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  searchFieldState: ReturnType<typeof useSearchFieldState>;
}

const BasicInfoTab = ({ searchFieldState }: BasicInfoTabProps) => {
  const { customer, setCustomer, account, setAccount } = searchFieldState;

  return (
    <div className='p-4'>
      <div className='flex items-center gap-3'>
        <Label className='w-[150px]'>Ngày c/từ (từ/đến)</Label>
        <DateRangeField
          label='Ngày c/từ (từ/đến)'
          fromDateName='ngay_ct1'
          toDateName='ngay_ct2'
          toFieldClassName='w-48'
          fromFieldClassName='w-48'
        />
      </div>

      {/* Số c/từ (từ/đến) */}
      <DocumentNumberRangeField formMode='add' label='Số c/từ (từ/đến)' fromName='so_ct1' toName='so_ct2' />

      {/* Mã khách hàng */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã NCC</Label>
        <SearchField<KhachHang>
          type='text'
          name='ma_kh'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục đối tượng'
          value={customer?.customer_code}
          relatedFieldValue={customer?.customer_name}
          onRowSelection={setCustomer}
          className='w-100'
        />
      </div>

      {/* Tài khoản nợ */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Tài khoản nợ</Label>
        <SearchField<TaiKhoan>
          type='text'
          name='tk'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          value={account?.code}
          relatedFieldValue={account?.name}
          onRowSelection={setAccount}
          className='w-100'
        />
      </div>

      {/* Diễn giải */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Diễn giải</Label>
        <div className='w-full'>
          <FormField name='dien_giai' type='text' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
